import api from "./api";

const StockTransferReportService = {
  getReport: async (params) => {
    const response = await api.get("/stockTransferReport/getReport", {
      params: {
        reportMode: params.reportMode || undefined,
        status: params.status || undefined,
        companyId: params.companyId || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
        transferType: params.transferType || undefined,
        fromCompanyId: params.fromCompanyId || undefined,
        fromProjectId: params.fromProjectId || undefined,
        fromStoreId: params.fromStoreId || undefined,
        itemCategoryId: params.itemCategoryId || undefined,
        itemId: params.itemId || undefined,
        toCompanyId: params.toCompanyId || undefined,
        toProjectId: params.toProjectId || undefined,
        toStoreId: params.toStoreId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;
  },
};

export default StockTransferReportService;
